<div class="field-container" (click)="openModal(field)">
    <div class="label">{{field.name}}</div>
    <div class="img-container">
        <img [src]="settings.getBaseUrl(true) + field.value" *ngIf="field.value">
        <div class="no-image" *ngIf="!field.value">
            <mat-icon svgIcon="photo-size-select-actual"></mat-icon>
            <span class="text" trans>Add</span>
        </div>

        <div class="actions-dropdown">
            <button class="no-style" [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()"><mat-icon svgIcon="settings" class="trigger-icon"></mat-icon></button>

            <mat-menu #actionsMenu>
                <div mat-menu-item (click)="remove()" *ngIf="field.value" trans>Remove</div>
                <div mat-menu-item (click)="useDefault()" *ngIf="field.defaultValue" trans>Use Default</div>
            </mat-menu>
        </div>

    </div>
</div>